module.exports = __webpack_public_path__ + "media/images/faces/female/2-f0ec48e5f2f8012629651e783c2725b4.jpg";